export default __webpack_public_path__ + "static/media/einstein-scene_1.5288e6fa.png";